const PaymentEndpoints = {
  product: {
    get: {
      method: 'POST',
      url: () => '/api/product/get',
    },
  },
  transaction: {
    create: {
      method: 'POST',
      url: () => '/api/transaction/create',
    },
    list: {
      method: 'POST',
      url: () => '/api/transaction/all',
    },
    invoice: {
      method: 'POST',
      url: () => '/api/transaction/invoice',
    },
  },
  subscription: {
    get: {
      method: 'GET',
      url: () => '/api/subscription/get',
    },
    cancel: {
      method: 'GET',
      url: () => '/api/subscription/cancel',
    },
    update: {
      method: 'GET',
      url: () => '/api/subscription/update',
    },
    upgrade: {
      method: 'POST',
      url: () => '/api/subscription/upgrade',
    },
  },
} as const;

type PaymentEndpoints = typeof PaymentEndpoints;

export type { PaymentEndpoints };
export default PaymentEndpoints;
